import { render, staticRenderFns } from "./DispatchSummarySignatories.vue?vue&type=template&id=18a68fd3&scoped=true"
import script from "./DispatchSummarySignatories.vue?vue&type=script&lang=js"
export * from "./DispatchSummarySignatories.vue?vue&type=script&lang=js"
import style0 from "./DispatchSummarySignatories.vue?vue&type=style&index=0&id=18a68fd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a68fd3",
  null
  
)

export default component.exports